import { User } from '@app/shared/models/user';
import { createAction, props } from '@ngrx/store';
import { GetUserMetricStatisticInput } from '@smash-sdk/transfer/ejs/01-2024';

// Load Members
export const loadMembers = createAction(
  '[Members] Load Members'
);

export const loadMembersSuccess = createAction(
  '[Members] Load Members Success',
  props<{ members: User[] }>()
);

export const loadMembersFailure = createAction(
  '[Members] Load Members Failure',
  props<{ error: any }>()
);

// Load Member Domains
export const loadMemberDomains = createAction(
  '[Members] Load Member Domains',
  props<{ id: string }>()
);

export const loadMemberDomainsSuccess = createAction(
  '[Members] Load Member Domains Success',
  props<{ domains: any[], attributableDomains: any[] }>()
);

export const loadMemberDomainsFailure = createAction(
  '[Members] Load Member Domains Failure',
  props<{ error: any }>()
);

// Load Member Groups
export const loadMemberGroups = createAction(
  '[Members] Load Member Groups',
  props<{ id: string }>()
);

export const loadMemberGroupsSuccess = createAction(
  '[Members] Load Member Groups Success',
  props<{ groups: any[], attributableGroups: any[] }>()
);

export const loadMemberGroupsFailure = createAction(
  '[Members] Load Member Groups Failure',
  props<{ error: any }>()
);

export const resetCreation = createAction(
  '[Members] Reset Creation Member',
);

export const loadMember = createAction(
  '[Members] Load Member',
  props<{ id: string }>()
);

export const loadMemberSuccess = createAction(
  '[Members] Load Member Success',
  props<{ member: User }>()
);

export const loadMemberFailure = createAction(
  '[Members] Load Member Failure',
  props<{ error: any }>()
);

export const updateMember = createAction(
  '[Members] Update Member',
  props<{ data: any }>()
);

export const updateMemberSuccess = createAction(
  '[Members] Update Member Success',
  props<{ member: User }>()
);

export const updateMemberFailure = createAction(
  '[Members] Update Member Failure',
  props<{ error: any }>()
);

// Add Member
export const addMember = createAction(
  '[Members] Add Member',
  props<{ member: User, teams?: any[], groups?: any[] }>()
);

export const addMemberSuccess = createAction(
  '[Members] Add Members Success',
  props<{ member: any }>()
);

export const addMemberFailure = createAction(
  '[Members] Add Members Failure',
  props<{ error: any }>()
);

// Import Members
export const initImportMembers = createAction(
  '[Members] Init Import Members',
  props<{ fileMembers: File[], csvContent: string }>()
);

export const checkContentFile = createAction(
  '[Members] Check Content File',
  props<{ fileMembers: File[], csvContent: string }>()
);

export const checkContentFileSuccess = createAction(
  '[Members] Check Content File Success',
);

export const checkContentFileFailure = createAction(
  '[Members] Check Content File Failure',
  props<{ error: any }>()
);

export const importMembers = createAction(
  '[Members] Import Members',
  props<{ members: any[] }>()
);

export const importMembersSuccess = createAction(
  '[Members] Import Members Success',
  props<{ members: any[], nonBlockingError?: any }>()
);

export const importMembersFailure = createAction(
  '[Members] Import Members Failure',
  props<{ error: any }>()
);

export const UpdateImportMembersStatus = createAction(
  '[Members] Update Import Members Status',
  props<{ importedMembers: any[] }>()
);

export const resetImportMembers = createAction(
  '[Members] Reset Import Members',
);

// Attach member to team
export const attachMemberToTeam = createAction(
  '[Members] Attach Member',
  props<{ member: User, team: any, role: any }>()
);

export const attachMemberToTeamSuccess = createAction(
  '[Members] Attach Members Success'
);

export const attachMemberToTeamFailure = createAction(
  '[Members] Attach Members Failure',
  props<{ error: any }>()
);

// Detach member from team
export const detachMemberFromTeam = createAction(
  '[Members] Detach Member',
  props<{ member: User, team: any }>()
);

export const detachMemberFromTeamSuccess = createAction(
  '[Members] Detach Members From Team Success'
);

export const detachMemberFromTeamFailure = createAction(
  '[Members] Detach Members From Team Failure',
  props<{ error: any }>()
);

// Attach member to group
export const attachMemberToGroup = createAction(
  '[Members] Attach Member To Group',
  props<{ member: any, group: any }>()
);

export const attachMemberToGroupSuccess = createAction(
  '[Members] Attach Members To Group Success'
);

export const attachMemberToGroupFailure = createAction(
  '[Members] Attach Members To Group Failure',
  props<{ error: any }>()
);

// Detach member from group
export const detachMemberFromGroup = createAction(
  '[Members] Detach Member From Group',
  props<{ member: User, group: any }>()
);

export const detachMemberFromGroupSuccess = createAction(
  '[Members] Detach Members From Group Success'
);

export const detachMemberFromGroupFailure = createAction(
  '[Members] Detach Members From Group Failure',
  props<{ error: any }>()
);

// Load attributable roles
export const loadAttributableRoles = createAction(
  '[Members] Load Attributable Roles',
);

export const loadAttributableRolesSuccess = createAction(
  '[Members] Load Attributable Roles Success',
  props<{ roles: any }>()
);

export const loadAttributableRolesFailure = createAction(
  '[Members] Load Attributable Roles Failure',
  props<{ error: any }>()
);

// Load attributable groups
export const loadAttributableGroups = createAction(
  '[Members] Load Attributable Groups',
);

export const loadAttributableGroupsSuccess = createAction(
  '[Members] Load Attributable Groups Success',
  props<{ groups: any[] }>()
);

export const loadAttributableGroupsFailure = createAction(
  '[Members] Load Attributable Groups Failure',
  props<{ error: any }>()
);

export const deleteMember = createAction(
  '[Members] Delete Member',
  props<{ member: User }>()
);

export const deleteMemberSuccess = createAction( // Response ?
  '[Members] Delete Member Success',
);

export const deleteMemberFailure = createAction(
  '[Members] Delete Member Failure',
  props<{ error: any }>()
);

export const inviteMember = createAction(
  '[Members] Invite Member',
  props<{ id: string }>()
)

export const inviteMemberSuccess = createAction(
  '[Members] Invite Member Success'
)

export const inviteMemberFailure = createAction(
  '[Members] Invite Member Failure',
  props<{ error: any }>()
)

export const switchMemberRole = createAction(
  '[Members] Switch Member Role',
  props<{ member: User, roleToDettach: any, roleToAttach: any }>()
);

export const switchMemberRoleSuccess = createAction(
  '[Members] Switch Member Role Success'
);

export const switchMemberRoleFailure = createAction(
  '[Members] Switch Member Role Failure',
  props<{ error: any }>()
);

// Root role
export const addRootRoleToMember = createAction(
  '[Members] Add Root Role',
  props<{ member: User }>()
);

export const addRootRoleToMemberSuccess = createAction(
  '[Members] Add Root Role Success'
);

export const addRootRoleToMemberFailure = createAction(
  '[Members] Add Root Role Failure',
  props<{ error: any }>()
);

export const removeRootRoleFromMember = createAction(
  '[Members] Remove Root Role',
  props<{ member: User }>()
);

export const removeRootRoleFromMemberSuccess = createAction(
  '[Members] Remove Root Role Success'
);

export const removeRootRoleFromMemberFailure = createAction(
  '[Members] Remove Root Role Failure',
  props<{ error: any }>()
);

// Counter

export const loadMemberTransferCount = createAction(
  '[Members] Load Member Transfer Count',
  props<{ user: string, period: string,  unit: GetUserMetricStatisticInput['unit'] }>()
);

export const loadMemberTransferCountSuccess = createAction(
  '[Members] Load Member Transfer Count Success',
  props<{ transferCountSeries: any[] }>()
);

export const loadMemberTransferCountFailure = createAction(
  '[Members] Load Member Transfer Count Failure',
  props<{ error: any }>()
);

export const loadMemberSizeCount = createAction(
  '[Members] Load Member Size Count',
  props<{ user: string, period: string,  unit: GetUserMetricStatisticInput['unit'] }>()
);

export const loadMemberSizeCountSuccess = createAction(
  '[Members] Load Member Size Count Success',
  props<{ sizeCountSeries: any[] }>()
);

export const loadMemberSizeCountFailure = createAction(
  '[Members] Load Member Size Count Failure',
  props<{ error: any }>()
);

export const loadMemberFileCount = createAction(
  '[Members] Load Member File Count',
  props<{ user: string, period: string,  unit: GetUserMetricStatisticInput['unit'] }>()
);

export const loadMemberFileCountSuccess = createAction(
  '[Members] Load Member File Count Success',
  props<{ fileCountSeries: any[] }>()
);

export const loadMemberFileCountFailure = createAction(
  '[Members] Load Member File Count Failure',
  props<{ error: any }>()
);
